import _ from 'lodash';
import { del, get, patch, post } from './agent';

const harvest = {
  workspace: (workspacesUrl) => {
    const url = _([workspacesUrl, 'harvest']).compact().join('/');

    return {
      get: () => get(url),
      setup: (body) => post(url, body),
      updateSyncSettings: (body) => patch(url.concat('/sync-settings'), body),
      manualSync: (body) => post(url.concat('/manual-sync'), body),
      getResults: () => get(url.concat('/results')),
      getImportedResults: () => get(url.concat('/results/imported')),
      getSyncs: () => get(url.concat('/syncs')),
      getSyncLog: (id) => get(url.concat('/syncs/', id, '/log')),
      remove: () => del(url),
    };
  },
};

export default harvest;
